import React, { FC } from "react"

import { Button, Group, Modal, ModalProps, Stack, Text } from "@mantine/core"
import { IconTrash } from "@tabler/icons-react"

import useDeleteGroup from "./useDeleteGroup"
import { GroupDocument } from "../../../contexts/devices-context"
import { useLanguage } from "../../../contexts/language-context"

type DeleteGroupModalProps = ModalProps & {
    group: GroupDocument
}

const DeleteGroupModal: FC<DeleteGroupModalProps> = ({ group, ...props }) => {
    const { onDelete, processing } = useDeleteGroup(group, props.onClose)
    const { L } = useLanguage()

    return (
        <Modal {...props} title={<Text weight="bold">{L("Delete group")}</Text>}>
            <Stack>
                <Text>
                    {L(
                        "Are you sure that you want to delete group %s? All settings of this group will be lost. %s",
                        <Text weight="bold" span>
                            {group.name}
                        </Text>,
                        L("This action cannot be reverted."),
                    )}
                </Text>
                <Group position="right" noWrap>
                    <Button variant="subtle" onClick={props.onClose}>
                        {L("Cancel")}
                    </Button>
                    <Button
                        variant="filled"
                        color="red"
                        leftIcon={<IconTrash size={16} />}
                        loading={processing}
                        onClick={onDelete}
                    >
                        {L("Delete group")}
                    </Button>
                </Group>
            </Stack>
        </Modal>
    )
}

export default DeleteGroupModal
